import React from 'react';

interface TranslatorInputProps {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

const TranslatorInput: React.FC<TranslatorInputProps> = ({ value, onChange }) => {
  return (
    <div className="bg-white border border-gray-200 rounded-xl shadow-lg flex flex-col h-full">
      <textarea
        value={value}
        onChange={onChange}
        placeholder="Enter English text..."
        className="w-full flex-grow bg-transparent p-4 text-gray-800 text-lg resize-none focus:outline-none focus:ring-2 focus:ring-pink-300 rounded-xl placeholder-gray-400"
        style={{ minHeight: '300px' }}
        aria-label="English text input"
      />
    </div>
  );
};

export default TranslatorInput;